import React, { useContext, useEffect, useRef, useState } from "react";
import "./CustomDropDown.css";
import DropdownSelectIcon from "../SVGComponents/DropdownSelectIcon";
import CustomDropDownList from "./CustomDropDownList";
import { getClientProviders } from "../../service/StudyListService";
import DropdownUnselectIcon from "../SVGComponents/DropdownUnselectIcon";
import {TooltipHost } from "@fluentui/react";
import toastContext from "../../context/toast/ToastContext";
import CustomToolTipHost from "../CustomToolTipHost/CustomToolTipHost";

const CustomDropDown = (props) => {

  const { showToastv2, updateToastv2, list, setList } =
  useContext(toastContext);

  const [showDropdownList, setDropdownList] = useState(false);
  const [selectedItem,setSelectedItem] = useState("");

  const handleOnSelect = (val,key) => {
    console.log(val,key);
    setSelectedItem(val);
    props.getSelectedValue(val,key,props.index);
  }

  useEffect(() => {
      if (list.length == 0) {
        handleClearSelection();
    }
  }, [list]);

  useEffect(()=>{
      if(props.reassignClick != null && props.reassignClick != undefined && props.reassignClick){
        setDropdownList(true);
      }
  },[props.reassignClick])

  const handleClearSelection = () => {
    setSelectedItem("");
    setDropdownList(false);
  }

  useEffect(()=>{
    if(props.setHeightIncrease != null && props.setHeightIncrease != undefined){
      props.setHeightIncrease(showDropdownList);
    }
  },[showDropdownList])

  useEffect(() => {
    console.log(props.data)
  }, [])


  return (
    <div className="custom-dropdown" 
    style={{width:props.widthSelect != null && props.widthSelect != undefined ? props.widthSelect : "160px"}} 
    onClick={(ev)=>{ev.stopPropagation();setDropdownList((prev)=>!prev)}}>
      <div className="custom-dropdown-title">
      <CustomToolTipHost content={selectedItem != ""?selectedItem:props.placeholder} id={"tooltip_"}>
        <span className="custom-dropdown-placeholder" style={{width:"121px"}}>
        {selectedItem != ""?selectedItem:props.placeholder}
        </span></CustomToolTipHost>
        
        <div className="custom-dropdown-icon" onClick={(ev)=>{if(selectedItem != ""){ev.stopPropagation();setDropdownList(false);handleClearSelection()}}}>
        {selectedItem == ""?<DropdownSelectIcon />
        :<DropdownUnselectIcon unselectRadiologist = {()=>props.unselectRadiologist(props.data.row.original.id)} />}
        </div>
        
      </div>
      {showDropdownList && <CustomDropDownList
            show={showDropdownList}
            onClickOutside={() => {
              setDropdownList(false);
            }}
            data = {props.data}
            assignmentNumber = {props.index}
            handleOnSelect = {handleOnSelect}
            childRef={props.childRef != null && props.childRef != undefined ? props.childRef : null}
        />}
    </div>

    // <div className="dropdown" ref={ref}>
    //   <div className="dropdown-toggle" onClick={() => setIsOpen(!isOpen)}>
    //     {selectedOption ? (
    //       <>
    //         {selectedOption}
    //         <span className="clear-icon" onClick={clearSelection}>
    //           &#10005;
    //         </span>
    //       </>
    //     ) : (
    //       'Select an option'
    //     )}
    //   </div>
    //   {isOpen && (
    //     <div className="dropdown-menu">
    //       <input
    //         type="text"
    //         value={filterText}
    //         onChange={handleFilterChange}
    //         placeholder="Filter options"
    //       />
    //       <ul>
    //         {filteredOptions.map((option) => (
    //           <li
    //             key={option}
    //             onClick={() => handleOptionSelect(option)}
    //           >
    //             {option}
    //           </li>
    //         ))}
    //       </ul>
    //     </div>
    //   )}
    // </div>
  );
};

export default CustomDropDown;
